import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {Subscription} from "rxjs";
import {filter, first} from "rxjs/operators";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {AiBuilderService} from "../../../../../websites/website/ai-builder/service/ai-builder.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {User} from '../../../../../user/user';
import {BuilderHistoryService} from "../../../../builder-history.service";
import {BuilderStepsEnum} from "../../../../builder-tour.enum";
import {BuilderSectionsInteractionService} from "../../../../builder-sections-interaction.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {VibeCodingFlowService} from "../../../../../shared/services/vibe-coding-flow.service";

@Component({
    selector: 'db-choose-business-type',
    templateUrl: './choose-business-type.component.html',
    styleUrl: './choose-business-type.component.scss',
    standalone: false
})
export class ChooseBusinessTypeComponent implements OnInit, AfterViewInit {
  @Input() companyTypesForView: any;
  @Input() companyTypes: any;
  @Input() popupMode: boolean;
  @Input() hasEcommerceService: boolean = true;
  @Input() selectedCompanyType: any;
  @Input() selectedCategoryType: string;
  @Input() selectedBusinessCategory: string;
  @Input() user: User;
  @Input() uniqueId: string;
  @Input() isMobile: boolean;

  websiteType: string = '';
  loading: boolean = false;
  builderStep = BuilderStepsEnum;

  @Output() back = new EventEmitter<void>();
  @Output() mobileNext = new EventEmitter<void>();
  @Output() companyTypeSelected = new EventEmitter<string>();
  @Output() companyTypeSearchedList = new EventEmitter<any[]>();
  @Output() categoryType = new EventEmitter<string>();
  private _categoriesRequestSubscription: Subscription;

  constructor(
    private _builderService: AiBuilderService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _builderHistoryService: BuilderHistoryService,
    public builderInteractionsService: BuilderSectionsInteractionService,
    private _cdr: ChangeDetectorRef,
    private _router: Router,
    private _route: ActivatedRoute,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private _activeModal: DbActiveModal,
    private _vibeCodingFlowService: VibeCodingFlowService
  ) {
  }

  ngOnInit() {
    this.isMobile ? this.builderInteractionsService.disableNextButton.next(true) : this.builderInteractionsService.disableNextButton.next(!this.selectedCompanyType);
    this.builderInteractionsService.setBackAction(() => {
      this.backToPreviousStep();
    });
    this.isMobile && this.checkMobileData();
  }

  ngAfterViewInit() {
    const inputs = this.elRef.nativeElement.querySelectorAll('input, textarea');

    inputs.forEach((input: HTMLElement) => {
      // Disable zoom on the first focus
      this.renderer.listen(input, 'focus', () => this.disableZoom());
      this.renderer.listen(input, 'touchstart', () => this.disableZoom());
    });
  }

  // Disable zoom by setting viewport to maximum scale 1.0
  disableZoom() {
    const viewport = document.querySelector("meta[name=viewport]");
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      );
    }
  }

  checkMobileData() {
    const state = this._builderHistoryService.getFormData();

    if (state?.oldFormData) {
      this._cdr.detectChanges();
      this.companyTypesForView = state?.companyTypes;
      this.selectCompanyType({value: state?.oldFormData?.business_type, group: state?.oldFormData?.business_category});
    }
  }

  public searchCategory($event) {
    if (this._categoriesRequestSubscription) {
      this._categoriesRequestSubscription.unsubscribe();
      this._categoriesRequestSubscription = null;
    }
    if ($event === '') {
      return this.companyTypesForView = this.companyTypes;
    }
    this._categoriesRequestSubscription = this._builderService.searchCategories($event, false, false)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          const searchedResult = response.data.map((companyType) => (
            {
              label: companyType.title,
              highlightedLabel: companyType.title.replace(new RegExp($event, "gi"), (match) => `<span class="ds-highlighted">${match}</span>`),
              value: companyType.title,
              type: companyType.type,
              group: companyType.group
            }
          ));

          // const uniqueResults = searchedResult.filter(newItem =>
          //   !this.companyTypesForView.some(existingItem => existingItem.label === newItem.label)
          // );
          const combinedArray = [...searchedResult, ...this.companyTypesForView];
          const dataToPass = {companyTypes: this.companyTypesForView};
          this.isMobile && this._builderHistoryService.saveFormData(dataToPass);
          this.companyTypesForView = combinedArray.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.value === item.value
              ))
          );
        } else {
          this.companyTypesForView = this.companyTypes;
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this._cdr.detectChanges();
      });
  }

  public selectCompanyType(option: { value: IDsDropdownOption['value'], group: IDsDropdownOption['group'] }) {
    this.selectedCompanyType = option?.value as string;
    this.selectedBusinessCategory = option?.group as string;
    this.builderInteractionsService.businessCategory.next(this.selectedBusinessCategory );
    !this.isMobile && this.builderInteractionsService.disableNextButton.next(false);
    this.companyTypeSelected.emit(this.selectedCompanyType);
    this.companyTypeSearchedList.emit(this.companyTypesForView);
    this.categoryType.emit(this.companyTypesForView[0].type);
  }

  public proceedToNextQuestion(): void {
    const vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow();
  }

  backToPreviousStep(): void {
    this.popupMode ?  this._activeModal.close() : this.back.emit();
  }

}
